<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'view'">
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width:100%">
      <tr  class="back">
        <th>Branch</th>
        <th>Comment</th>
        <th>
          Time
        </th>
      </tr>
      <tr class="td" *ngFor="let app of data">
        <td>{{app.BranchName}}</td>
        <td>{{app.Comment}}</td>
        <td>
          {{app.ScheduleDate | date}} <span style="padding-left: 10px; color: red;">{{app.ScheduleTime}}</span>
          <!-- <button mat-raised-button color="primary" (click)="view(app)">
            Edit
          </button> -->
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
          <p>{{Errors}}</p>
      </div>
    </div>
    <div class="last">
    </div>
  </div>

  <div *ngSwitchCase="'add'">
    <div class="post">
      <div class="title">Create SOC</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
              <mat-label>Name</mat-label>
              <input formControlName="SOC_NAME" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Short Code</mat-label>
              <input formControlName="SOC_Short_COde" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Remarks</mat-label>
              <input formControlName="SOC_REMARKs" matInput placeholder="">
            </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select formControlName="Status" matNativeControl required>
                <mat-option  value="Active">Active</mat-option>
                <mat-option value="Inactive">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
            <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="" style="margin-bottom: 30px;">
        <button class="create" type="submit" mat-raised-button color="primary" style="margin-left: 20px;">
          {{ isLoading? "Saving...": "Save"}}
        </button>
      </div>
    </div>
  </div>
</div>
